var _rect, _circle, _circle2, _circle3, _circle4, _path, _circle5, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCafe01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.228516,
    y: 0.529297,
    width: 350,
    height: 233,
    fill: "#7C82BC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240.058,
    cy: 140.249,
    r: 69.1201,
    transform: "rotate(-12.0382 240.058 140.249)",
    fill: "#232444"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.23,
    cy: 130.985,
    r: 63.4267,
    transform: "rotate(-12.0382 245.23 130.985)",
    fill: "#686CD3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.23,
    cy: 130.984,
    r: 60.4937,
    transform: "rotate(-12.0382 245.23 130.984)",
    fill: "#EBECFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.23,
    cy: 130.983,
    r: 59.0272,
    transform: "rotate(-12.0382 245.23 130.983)",
    fill: "#D97B5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.951 155.753L208.288 121.237L222.454 136.9L280.595 152.669L261.93 192.591C257.359 193.733 252.592 194.39 247.683 194.503C220.652 195.127 197.117 179.072 186.951 155.753Z",
    fill: "#1E1F2F",
    fillOpacity: 0.86
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.188,
    cy: 133.345,
    r: 35.1963,
    transform: "rotate(-15.7648 245.188 133.345)",
    fill: "#686CD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.516 166.722C275.808 161.276 287.032 141.222 281.586 121.93C276.139 102.638 256.085 91.4139 236.793 96.8601C219.435 101.76 208.609 118.487 210.58 135.844C211.758 154.717 227.823 169.271 246.809 168.487C250.024 168.354 253.119 167.79 256.041 166.853C256.199 166.81 256.358 166.767 256.516 166.722ZM256.041 166.853C270.602 162.182 280.862 148.24 280.201 132.219C279.407 112.983 263.169 98.0327 243.933 98.8267C224.697 99.6207 209.747 115.858 210.541 135.094C210.551 135.345 210.564 135.595 210.58 135.844C210.799 137.777 211.178 139.719 211.724 141.652C217.125 160.786 236.896 171.984 256.041 166.853Z",
    fill: "#333679"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.774 169.969C279.084 163.953 291.482 141.801 285.466 120.491C279.45 99.1807 257.298 86.7824 235.988 92.7984C214.678 98.8145 202.279 120.967 208.295 142.277C214.311 163.587 236.464 175.985 257.774 169.969ZM256.525 165.539C275.389 160.214 286.365 140.604 281.039 121.739C275.714 102.874 256.103 91.8986 237.239 97.2242C218.374 102.55 207.398 122.16 212.724 141.025C218.05 159.89 237.66 170.865 256.525 165.539Z",
    fill: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 281.396,
    y: 118.553,
    width: 16.1316,
    height: 6.59931,
    rx: 3.29966,
    transform: "rotate(-15.7648 281.396 118.553)",
    fill: "#F2F2F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe01);
export default __webpack_public_path__ + "static/media/cafe_01.0e5dade28ef00e05540eba95c70a946e.svg";
export { ForwardRef as ReactComponent };